import { render, staticRenderFns } from "./RecScroll.vue?vue&type=template&id=03f69b11&scoped=true&"
import script from "./RecScroll.vue?vue&type=script&lang=js&"
export * from "./RecScroll.vue?vue&type=script&lang=js&"
import style0 from "./RecScroll.vue?vue&type=style&index=0&id=03f69b11&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f69b11",
  null
  
)

export default component.exports